import { render, staticRenderFns } from "./CreateCredentialsFlow.vue?vue&type=template&id=6f95ef05&scoped=true"
import script from "./CreateCredentialsFlow.vue?vue&type=script&lang=js"
export * from "./CreateCredentialsFlow.vue?vue&type=script&lang=js"
import style0 from "./CreateCredentialsFlow.vue?vue&type=style&index=0&id=6f95ef05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95ef05",
  null
  
)

export default component.exports